import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const ModeContainer = styled.div`
  padding: ${({ theme }) => theme.spacing(1)};
`;

export const InputRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  align-items: center;

  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
`;

export const InputText = styled.span<{ $isError?: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};

  white-space: nowrap;
  color: ${({ theme, $isError }) =>
    $isError ? theme.palette.error.main : theme.palette.text.secondary};
`;
